import { DecimalPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { MechanicAddLunchShiftViewModel, MechanicLunchShiftViewModel, MechanicOpeningHoursViewModel } from '../../../business-entities/mechanic-opening-hours-view-model';
import { DealerWorkingHoursBusinessService } from '../../../business-services/dealer-working-hours.service';
import { MechanicService } from '../../../business-services/mechanic.service';
import * as Enums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { DealerOpeningHoursViewModel } from './../../../business-entities/dealer-opening-hours-view-model';
import { OccasionalShiftSaveViewModel } from '../../../business-entities/occasionalshift-save-view-model';

@Component({
  selector: 'app-edit-hours-mechanic',
  templateUrl: './edit-hours-mechanic.component.html',
  styleUrls: ['./edit-hours-mechanic.component.css']
})
export class EditHoursMechanicComponent implements OnInit {
  shiftTime: MechanicOpeningHoursViewModel[];
  id: number;
  dealerId: string;
  allowedTimesForSlotFrom: string[][] = [];
  allowedTimesForSlotTo: string[][] = [];
  allTimeStamps: string[] = [];
  lunchShift: MechanicLunchShiftViewModel = {
    id: 0,
    startTime: '00:00',
    endTime: '00:00',
    startTimeBreak1: '00:00',
    endTimeBreak1: '00:00',
    startTimeBreak2: '00:00',
    endTimeBreak2: '00:00',
    startTimeDate: null,
    endTimeDate: null,
    break1StartTimeDate: null,
    break1EndTimeDate: null,
    break2StartTimeDate: null,
    break2EndTimeDate: null,
    lunchStartTime: { hour:0, minute: 0 },
    lunchEndTime: { hour:0, minute: 0 },
    break1StartTime: { hour:0, minute: 0 },
    break1EndTime: { hour:0, minute: 0 },
    break2StartTime: { hour:0, minute: 0 },
    break2EndTime: { hour:0, minute: 0 },
  };
  addLunchShift: MechanicAddLunchShiftViewModel = {
    id: null,
    mechanicId: null,
    startTime: '00:00',
    endTime: '00:00',
    break1startTime: '00:00',
    break1endTime: '00:00',
    break2startTime: '00:00',
    break2endTime: '00:00',
  };
  dealerWorkingHours: DealerOpeningHoursViewModel[] = [];
  isDisabled: boolean = false;
  SelectedRadioButton: any = 1;
  OccasionList: OccasionalShiftSaveViewModel[] = [];
  occasionname: string;
  startdate: string;
  enddate: string;

  constructor(
    private service: MechanicService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private toaster: ToastrService,
    private decimalPipe: DecimalPipe,
    private dealerWorkingHoursService: DealerWorkingHoursBusinessService,
    private cookieservice: CookieService,
    private activeModal: NgbActiveModal,
    private cdrf: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.id = this.service.mechanicId;
    this.dealerId = this.service.dealerId;
    this.getAll();
  }

  async getAll() {
    await this.GetMechanicOpeningHoursById(this.id);
    await this.GetDealerMechanicLunchShiftDetails(this.id);
    this.GetDealerWorkingHours();
    this.getOccasionList();
  }

  getOccasionList() {
    this.dealerWorkingHoursService.GetSpecialOccasionList(this.dealerId).then((response) => {
      this.OccasionList = response.responseObject;
      let SelectedInput = this.OccasionList.filter(x => x.rowId == this.SelectedRadioButton);
      this.occasionname = SelectedInput[0].occasionName;
      this.startdate = (SelectedInput[0].startDate) ? Utility.GetFormattedDate(SelectedInput[0].startDate) : null;
      this.enddate = (SelectedInput[0].endDate) ? Utility.GetFormattedDate(SelectedInput[0].endDate) : null;
    })
  }
  ChangeOccasion() {
    this.cdrf.detectChanges();
    let SelectedInput = this.OccasionList.filter(x => x.rowId == this.SelectedRadioButton);
    this.occasionname = SelectedInput[0].occasionName;
    this.startdate = (SelectedInput[0].startDate) ? Utility.GetFormattedDate(SelectedInput[0].startDate) : null;
    this.enddate = (SelectedInput[0].endDate) ? Utility.GetFormattedDate(SelectedInput[0].endDate) : null;
    this.getAll();
  }

  async GetDealerWorkingHours() {
    this.dealerWorkingHours = await this.dealerWorkingHoursService.getDealerWorkingHoursDetails(this.dealerId, this.SelectedRadioButton);
    this.MapDealerWorkingHours();
  }

  MapDealerWorkingHours(): void {
    this.shiftTime = this.shiftTime?.map(x => {
      let dealerShiftDetails = '-';
      const workingHours = this.dealerWorkingHours.find(y => y.dayNumber === x.day);
      let date = (workingHours.openingTimeHrs ? Utility.ConvertToTimeFormat(workingHours.openingTimeHrs) : "00:00") + '-' + (workingHours.closingTimeHrs ? Utility.ConvertToTimeFormat(workingHours.closingTimeHrs) : "00:00")
      dealerShiftDetails = workingHours?.open ? date : 'lblClosed'
      return { ...x, dealerShiftDetails: dealerShiftDetails }
    });
  }
  private async GetMechanicOpeningHoursById(Id: number) {
    this.spinner.show();
    await this.service.GetMechanicOpeningHoursById(Id, this.SelectedRadioButton).then(result => {
      this.shiftTime = [];
      if (result.responseCode === Enums.ErrorCodes.SuccessCode && result.responseObject.length > 0) {
        this.shiftTime = result.responseObject;
        this.shiftTime.forEach(x => {
          x.openingTimeHrs = x.openingTimeHrsDate ? Utility.ConvertToTimeFormat(x.openingTimeHrsDate) : "00:00";
          x.closingTimeHrs = x.closingTimeHrsDate ? Utility.ConvertToTimeFormat(x.closingTimeHrsDate) : "00:00";
          x.dayText = this.service.getDayText(x.day);
          let openHour = x.openingTimeHrs.split(":");
          let closeHour = x.closingTimeHrs.split(":");
          x.openingTime = { hour: +openHour[0], minute: +openHour[1] }
          x.closingTime = { hour: +closeHour[0], minute: +closeHour[1] }
        })
        this.initializeAllTimeStamps();
        this.manageAllowedTimeStamps();
      }
      if (result.responseObject.result && result.responseObject.result.errorCode === Enums.ErrorCodes.MechanicShiftCode) {
        let errorMessage = this.translate.instant("lblErrorOccured");
        this.toaster.error(errorMessage);
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }

  private async GetDealerMechanicLunchShiftDetails(Id: number) {
    this.spinner.show();
    await this.service.GetDealerMechanicLunchShiftDetails(Id).then(result => {
      if (result.responseCode === Enums.ErrorCodes.SuccessCode && result.responseObject.length > 0) {
        this.lunchShift = result.responseObject[0];
        this.lunchShift.startTime = this.lunchShift.startTimeDate?Utility.ConvertToTimeFormat(this.lunchShift.startTimeDate):"00:00";
        this.lunchShift.endTime = this.lunchShift.endTimeDate?Utility.ConvertToTimeFormat(this.lunchShift.endTimeDate):"00:00";
        this.lunchShift.startTimeBreak1 = this.lunchShift.break1StartTimeDate?Utility.ConvertToTimeFormat(this.lunchShift.break1StartTimeDate):"00:00";
        this.lunchShift.endTimeBreak1 = this.lunchShift.break1EndTimeDate?Utility.ConvertToTimeFormat(this.lunchShift.break1EndTimeDate):"00:00";
        this.lunchShift.startTimeBreak2 = this.lunchShift.break2StartTimeDate?Utility.ConvertToTimeFormat(this.lunchShift.break2StartTimeDate):"00:00";
        this.lunchShift.endTimeBreak2 = this.lunchShift.break2EndTimeDate?Utility.ConvertToTimeFormat(this.lunchShift.break2EndTimeDate):"00:00";

        let startTime=this.lunchShift.startTime.split(":");
        let endTime=this.lunchShift.endTime.split(":");
        let startTimeBreak1=this.lunchShift.startTimeBreak1.split(":");
        let endTimeBreak1=this.lunchShift.endTimeBreak1.split(":");
        let startTimeBreak2=this.lunchShift.startTimeBreak2.split(":");
        let endTimeBreak2=this.lunchShift.endTimeBreak2.split(":");
        this.lunchShift.lunchStartTime = { hour: +startTime[0], minute:  +startTime[1] }
        this.lunchShift.lunchEndTime = { hour: +endTime[0], minute:  +endTime[1] }
        this.lunchShift.break1StartTime = { hour: +startTimeBreak1[0], minute:  +startTimeBreak1[1] }
        this.lunchShift.break1EndTime = { hour: +endTimeBreak1[0], minute:  +endTimeBreak1[1] }
        this.lunchShift.break2StartTime = { hour: +startTimeBreak2[0], minute:  +startTimeBreak2[1] }
        this.lunchShift.break2EndTime = { hour: +endTimeBreak2[0], minute:  +endTimeBreak2[1] }

        this.spinner.hide();
      }
      if (result.responseObject.length === 0 && result.responseCode.toString() === Enums.ErrorCodes.InvalidMechanicId) {
        let errorMessage = this.translate.instant("lblInvalidMechanicId");
        this.toaster.error(errorMessage);
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }


  EditMechanicOpeningHoursDetail(isSaveAndClose) {
    this.spinner.show();
    this.addLunchShift.id = this.lunchShift.id;
    this.addLunchShift.mechanicId = this.id;
    this.addLunchShift.startTime = Utility.ConvertLocalTimeToDateTime(this.lunchShift.startTime);
    this.addLunchShift.endTime = Utility.ConvertLocalTimeToDateTime(this.lunchShift.endTime);
    this.addLunchShift.break1startTime = Utility.ConvertLocalTimeToDateTime(this.lunchShift.startTimeBreak1);
    this.addLunchShift.break1endTime = Utility.ConvertLocalTimeToDateTime(this.lunchShift.endTimeBreak1);
    this.addLunchShift.break2startTime = Utility.ConvertLocalTimeToDateTime(this.lunchShift.startTimeBreak2);
    this.addLunchShift.break2endTime = Utility.ConvertLocalTimeToDateTime(this.lunchShift.endTimeBreak2);

    let viewModel =
    {
      dealerId: this.dealerId,
      MechanicShifts: JSON.parse(JSON.stringify(this.shiftTime)),
      dealerMechanicLunchShiftModel: this.addLunchShift,
      langCode: this.cookieservice.get('userSelectedLanguage'),
      OccasionId: this.SelectedRadioButton
    }

    viewModel.MechanicShifts.forEach(x => {
      let openingTime,closingTime
      if(x.openingTime == null){
        openingTime = '0:0:0'
      }
      else{
         openingTime = x.openingTime.hour + ":" + x.openingTime.minute + ":" + (x.openingTime.second == undefined ? '0' : x.openingTime.second);
      }
      if(x.closingTime == null){
        closingTime = '0:0:0'
      }
      else{
        closingTime = x.closingTime.hour + ":" + x.closingTime.minute + ":" + (x.closingTime.second == undefined ? '0' : x.closingTime.second);
      }
      x.openingTimeHrs = Utility.ConvertLocalTimeToDateTime(openingTime);
      x.closingTimeHrs = Utility.ConvertLocalTimeToDateTime(closingTime);
    }
    )
    this.service.UpdateMechanicOpeningHours(viewModel).then(res => {
      if (res.responseObject.result && res.responseObject.result.isValid === false) {
        this.spinner.hide();
        let dealerClosedErrorMessage = this.translate.instant("lblDealerIsClosed");
        let dealerClosedErrorDays = '';
        let slotTimeErrorMessage = this.translate.instant("lblMechanicSlotTimeError");
        let slotTimeErrordays = '';
        let errorMsgDealerClosed = '';
        let errorMsgShiftTime = '';
        res.responseObject.result.checkShiftTimes.forEach(x => {
          x.dayText = this.service.getDayText(x.day);
          if (x.isDealerClosed) {
            dealerClosedErrorDays = dealerClosedErrorDays + ' ' + x.dayText;
          }
          if (x.isShiftTimeError) {
            slotTimeErrordays = slotTimeErrordays + ' ' + x.dayText;
          }
        });
        if (res.responseObject.result.isLunchShiftError) {
          let internalErrorMessage = this.translate.instant("lblInvalidLunchShiftErrorMessage");
          this.toaster.error(internalErrorMessage);
        }
        if (dealerClosedErrorDays != '') {
          errorMsgDealerClosed += dealerClosedErrorMessage + dealerClosedErrorDays;
          this.toaster.error(errorMsgDealerClosed);
        }
        if (slotTimeErrordays != '') {
          errorMsgShiftTime += slotTimeErrorMessage + slotTimeErrordays;
          this.toaster.error(errorMsgShiftTime);
        }
      }
      else {
        if (res.responseObject.isLunchShiftError) {
          let internalErrorMessage = this.translate.instant("lblLunchShiftErrorMessage");
          this.spinner.hide();
          this.toaster.error(internalErrorMessage);
        }
        else {
          this.spinner.hide();
          let update = true;
          if (update) {
            let successMessage = this.translate.instant("lblShiftTimingsSuccessMessage");
            this.toaster.success(successMessage);
            localStorage.setItem('lastMechanic', JSON.stringify(this.addLunchShift));
          }
          if (isSaveAndClose) {
            this.activeModal.close({ success: true });
          }
          else {
            this.ngOnInit();
          }
        }
      }
    });
  }


  getstartHours(value: any, _model: any) {
    this.lunchShift.startTime = (value.hour.toString().length === 1 ? ("0" + value.hour) : value.hour) + ":" + (value.minute.toString().length === 1 ? ("0" + value.minute) : value.minute);
  }

  getendHours(value: any, _model: any) {
    this.lunchShift.endTime = (value.hour.toString().length===1? ("0"+value.hour) : value.hour) + ":" + (value.minute.toString().length===1? ("0"+value.minute) : value.minute) ;
  }

  getstartHoursBreak1(value: any, _model: any) {
    this.lunchShift.startTimeBreak1 = (value.hour.toString().length===1? ("0"+value.hour) : value.hour) + ":" + (value.minute.toString().length===1? ("0"+value.minute) : value.minute) ;
  }

  getendHoursBreak1(value: any, _model: any) {
    this.lunchShift.endTimeBreak1 = (value.hour.toString().length===1? ("0"+value.hour) : value.hour) + ":" + (value.minute.toString().length===1? ("0"+value.minute) : value.minute) ;
  }

  getstartHoursBreak2(value: any, _model: any) {
    this.lunchShift.startTimeBreak2 = (value.hour.toString().length===1? ("0"+value.hour) : value.hour) + ":" + (value.minute.toString().length===1? ("0"+value.minute) : value.minute) ;
  }

  getendHoursBreak2(value: any, _model: any) {
    this.lunchShift.endTimeBreak2 = (value.hour.toString().length===1? ("0"+value.hour) : value.hour) + ":" + (value.minute.toString().length===1? ("0"+value.minute) : value.minute) ;
  }
  onChangeOpeningHours(index: number, time: any): void {
    const zeroTime = '00:00:00';
    if (time != null) {
      this.shiftTime[index].openingTimeHrs = (time.hour.toString().length === 1 ? ("0" + time.hour) : time.hour) + ":" + (time.minute.toString().length === 1 ? ("0" + time.minute) : time.minute) + ":" + (time.second.toString().length === 1 ? ("0" + time.second) : time.second);
      this.setAllowedClosingTime(index, this.shiftTime[index].openingTimeHrs);
      if (this.shiftTime[index].closingTimeHrs === zeroTime) {
        const openingTimeIndex = this.allTimeStamps.findIndex(x => x === this.shiftTime[index].openingTimeHrs);
        const minClosingTimeIndex = openingTimeIndex + 1;
        this.shiftTime[index].closingTimeHrs = this.allTimeStamps[minClosingTimeIndex];
      }
    }
    else {
      this.shiftTime[index].openingTimeHrs = zeroTime;
      this.shiftTime[index].closingTimeHrs = zeroTime;
    }
  }

  onChangeClosingHours(index: number, time: any): void {
    const zeroTime = '00:00:00';
    if (time != null) {
      let timeValue = (time.hour.toString().length === 1 ? ("0" + time.hour) : time.hour) + ":" + (time.minute.toString().length === 1 ? ("0" + time.minute) : time.minute) + ":" + (time.second.toString().length === 1 ? ("0" + time.second) : time.second);
      if (this.shiftTime[index].openingTimeHrs < timeValue) {
        this.isDisabled = false;
        this.shiftTime[index].closingTimeHrs = timeValue;
        this.setAllowedOpeningTime(index, timeValue);
      }
      else {
        this.isDisabled = true;
        let errorMessage = this.translate.instant("lblSlotTimeError");
        this.toaster.error(errorMessage);
      }
    }
    else {
      this.shiftTime[index].openingTimeHrs = zeroTime;
      this.shiftTime[index].closingTimeHrs = zeroTime;
    }
  }

  initializeAllTimeStamps(): void {
    const totalHoursInDay = 24;
    const totalMinsInHour = 60;
    const timeDifferenceInMins = 15;
    for (let i = 0; i < totalHoursInDay; i++) {
      for (let j = 0; j < totalMinsInHour; j += timeDifferenceInMins) {
        const time = `${this.decimalPipe.transform(i, '2.0-0')}:${this.decimalPipe.transform(j, '2.0-0')}`;
        this.allTimeStamps.push(time);
      }
    }
    this.shiftTime.forEach(() => {
      this.allowedTimesForSlotFrom.push(this.allTimeStamps.slice());
      this.allowedTimesForSlotTo.push(this.allTimeStamps.slice());
    })
  }

  manageAllowedTimeStamps(): void {
    this.manageAllowedTimeStampsForSlotFromInput();
    this.manageAllowedTimeStampsForSlotToInput();
  }
  manageAllowedTimeStampsForSlotToInput(): void {
    const zeroTime = '00:00';
    this.shiftTime.forEach((workingHours, index) => {
      const openingTimeInHours = workingHours.openingTimeHrs;
      if (openingTimeInHours === zeroTime) {
        this.allowedTimesForSlotTo[index] = this.allTimeStamps;
      } else {
        this.setAllowedClosingTime(index, openingTimeInHours);
      }
    });
  }
  manageAllowedTimeStampsForSlotFromInput(): void {
    const zeroTime = '00:00';
    this.shiftTime.forEach((workingHours, index) => {
      const closingTimeInHours = workingHours.closingTimeHrs;
      if (closingTimeInHours === zeroTime) {
        this.allowedTimesForSlotFrom[index] = this.allTimeStamps;
      } else {
        this.setAllowedOpeningTime(index, closingTimeInHours);
      }
    });
  }
  setAllowedOpeningTime(index: number, closingTime: string): void {
    const closingTimeIndex = this.allTimeStamps.findIndex(x => x === closingTime);
    this.allowedTimesForSlotFrom[index] = closingTimeIndex > -1 ? this.allTimeStamps.slice(0, closingTimeIndex) : this.allTimeStamps.slice();
  }

  setAllowedClosingTime(index: number, openingTime: string): void {
    const openingTimeIndex = this.allTimeStamps.findIndex(x => x === openingTime);
    this.allowedTimesForSlotTo[index] = openingTimeIndex > -1 ? this.allTimeStamps.slice(openingTimeIndex + 1) : this.allTimeStamps.slice();
  }

  OnClose() {
    this.activeModal.close({ success: true });
  }
}
